module.exports = __webpack_public_path__ + "static/media/tom-wiggle.f38a96d0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/tom-wiggle.gif
// module id = 58
// module chunks = 0